import React, { useEffect } from 'react';
import { useLocation, useNavigate, useOutletContext, useParams } from 'react-router-dom';
import Lottie from 'lottie-react';
import { LoadingSpinnerAnimation } from 'assets/animations';
import { useAppSelector } from 'hooks';
import { selectCurrentTeam } from 'containers/app/appSlice';
import SidePanel from 'components/side-panel/SidePanel';
import { useLazyGetInvoiceByIdQuery } from '../api';
import InvoiceUrlShare from './InvoiceUrlShare';

const ShareUrlPanel: React.FC = () => {
  const currentTeam = useAppSelector(selectCurrentTeam);
  const { handleSidePanelClose, resetInvoicesQuery } = useOutletContext<any>() ?? {};
  const { invoiceId, rootInvoiceId } = useParams();
  const location = useLocation();
  const navigate = useNavigate();

  const [getInvoiceByIdQuery, getInvoiceByIdResponse] = useLazyGetInvoiceByIdQuery();
  const { data: invoiceData, isSuccess: invoiceDataSuccess, isFetching: fetchingInvoiceData } = getInvoiceByIdResponse;

  useEffect(() => {
    if (invoiceId || rootInvoiceId)
      getInvoiceByIdQuery({ invoiceId: invoiceId ? invoiceId : rootInvoiceId, teamId: currentTeam?.id });
  }, []);

  const handleBackClick = () => {
    navigate(-1);
  };

  return (
    <SidePanel isOpen={true} onClose={handleSidePanelClose} shouldAnimate={location?.state?.shouldAnimate}>
      <div className="h-full w-96 px-[26px] pt-[30px]">
        {fetchingInvoiceData ? (
          <div className="flex h-full w-full items-center justify-center">
            <Lottie className="h-28 w-28" animationData={LoadingSpinnerAnimation} loop={true} />
          </div>
        ) : (
          invoiceDataSuccess && (
            <InvoiceUrlShare
              invoiceData={invoiceData}
              onBack={handleBackClick}
              resetInvoicesQuery={resetInvoicesQuery}
            />
          )
        )}
      </div>
    </SidePanel>
  );
};

export default ShareUrlPanel;
